<template>
  <div>
    <topbar></topbar>
    <div class="container">
      <purchases></purchases>
      <h2 class="title is-2 centered">Tickets</h2>
      <tickets></tickets>
      <about></about>
    </div>

  </div>

</template>

<script>
import Topbar from './layout/Topbar'
import Purchases from './layout/Purchases'
import Tickets from './layout/Tickets'
import About from './layout/About'

export default {
  name: 'index',
  components: {
    Topbar,
    Purchases,
    Tickets,
    About
  },
  data () {
    return {

    }
  }
}
</script>

<style>
.container {
  top: 20px;;
}
.title {
  color: rgb(255,255,255) !important;
}
.centered{
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// Index.vue?408648fd